import(/* webpackMode: "eager", webpackExports: ["BitcoinIntegrationContent"] */ "/app/components/frontend/features/feature-detail/BitcoinIntegrationContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CryptoCurrencyMLMSoftwareContent"] */ "/app/components/frontend/features/feature-detail/CryptoCurrencyMLMSoftwareContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmailSystemContent"] */ "/app/components/frontend/features/feature-detail/EmailSystemContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EPinContent"] */ "/app/components/frontend/features/feature-detail/EPinContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EVoucherContent"] */ "/app/components/frontend/features/feature-detail/EVoucherContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EWalletContent"] */ "/app/components/frontend/features/feature-detail/EWalletContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GenealogyTreeContent"] */ "/app/components/frontend/features/feature-detail/GenealogyTreeContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntegrationWithEcommerceSolutionsContent"] */ "/app/components/frontend/features/feature-detail/IntegrationWithEcommerceSolutionsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingAutomationContent"] */ "/app/components/frontend/features/feature-detail/MarketingAutomationContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaymentGatewayIntegrationContent"] */ "/app/components/frontend/features/feature-detail/PaymentGatewayIntegrationContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReplicatingWebsiteContent"] */ "/app/components/frontend/features/feature-detail/ReplicatingWebsiteContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmsIntegrationContent"] */ "/app/components/frontend/features/feature-detail/SmsIntegrationContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TicketSystemContent"] */ "/app/components/frontend/features/feature-detail/TicketSystemContent.tsx");
